import '../css/SpiralMenu.css';
import { useNavigation } from '../function/navigation';

function ProductSizeMenu() {
  const { nav, dispatch } = useNavigation();

  const handleItemClick = (itemId) => {
    const value = itemId !== nav.productSizeView ? itemId : null;
    dispatch({ type: 'productSizeView', payload: value });
  };

  return (
    <div className="spiral-menu product-size">
      {['upper-end', 'windings', 'lower-end'].map((item) => (
        <div
          key={item}
          className={`spiral-menu-item ${nav.productSizeView === item ? 'active' : ''}`}
          onClick={() => handleItemClick(item)}
        >
          {item}
        </div>
      ))}
    </div>
  );
}

export default ProductSizeMenu;
